"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemEscrow = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./ItemEscrow.css"));
var _clsx = require("clsx");
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ItemEscrow = props => {
  return /*#__PURE__*/React.createElement("li", {
    className: (0, _clsx.clsx)(styles['item'], styles[props.iconType])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText2, null, props.title), /*#__PURE__*/React.createElement(_uiKit.IconButton, {
    onClick: props.onEscrowButtonClick,
    icon: /*#__PURE__*/React.createElement(_icons.IconFunctionalInformationCircle16, null)
  })), /*#__PURE__*/React.createElement(_uiKit.UIText3, {
    color: 'gray40_100'
  }, props.label)));
};
exports.ItemEscrow = ItemEscrow;